import {
  FetchDepartureSchedulePropsT,
  FetchDepartureScheduleOnePropsT,
  FetchDepartureScheduleFiltersPropsT,
  DepartureScheduleT,
  DepartureScheduleFiltersT,
} from "@interfaces/departure-schedule";

import { createEffect, createEvent, createStore } from "effector";

import { EventStateStoreT } from "@interfaces/common";

import DepartureScheduleService from "@services/departure-schedule-service";

// DepartureSchedule
export const setDepartureSchedule = createEvent<DepartureScheduleT[]>();
export const pushToDepartureSchedule = createEvent<DepartureScheduleT[]>();
export const updateDepartureSchedule = createEvent<DepartureScheduleT>();
export const removeDepartureSchedule = createEvent<number>();

export const $DepartureSchedule = createStore<DepartureScheduleT[]>([])
  .on(setDepartureSchedule, (_, newState) => newState)
  .on(pushToDepartureSchedule, (oldState, newState) => [
    ...newState,
    ...oldState,
  ])
  .on(updateDepartureSchedule, (oldState, updatedDepartureSchedule) =>
    oldState.map((departureSchedule) => {
      if (departureSchedule.id === updatedDepartureSchedule.id) {
        departureSchedule = updatedDepartureSchedule;
      }
      return departureSchedule;
    })
  )
  .on(removeDepartureSchedule, (oldState, departureScheduleId) =>
    oldState.filter(
      (departureSchedule) => departureSchedule.id !== departureScheduleId
    )
  );

// DepartureSchedule STATES
export const setDepartureScheduleStates = createEvent<EventStateStoreT>();

export const $DepartureScheduleStates = createStore<EventStateStoreT>({
  isFetched: false,
  isLoading: true,
  error: false,
}).on(setDepartureScheduleStates, (_, newState) => newState);

// SELECTED DepartureSchedule
export const setSelectedDepartureSchedule = createEvent<DepartureScheduleT>();
export const resetSelectedDepartureSchedule = createEvent();

export const $SelectedDepartureSchedule =
  createStore<DepartureScheduleT | null>(null)
    .on(setSelectedDepartureSchedule, (_, newState) => newState)
    .reset(resetSelectedDepartureSchedule);

// SELECTED DepartureSchedule STATES
export const setDepartureScheduleOneStates = createEvent<EventStateStoreT>();

export const $DepartureScheduleOneStates = createStore<EventStateStoreT>({
  isFetched: false,
  isLoading: true,
  error: false,
}).on(setDepartureScheduleOneStates, (_, newState) => newState);

// FILTERS DepartureSchedule
export const setDepartureScheduleFilters = createEvent<DepartureScheduleFiltersT>();

export const $DepartureScheduleFilters = createStore<DepartureScheduleFiltersT>({} as DepartureScheduleFiltersT)
  .on(setDepartureScheduleFilters, (_, newState) => newState)

// FILTERS DepartureSchedule STATES
export const setDepartureScheduleFiltersStates = createEvent<EventStateStoreT>();

export const $DepartureScheduleFiltersStates = createStore<EventStateStoreT>({
  isFetched: false,
  isLoading: true,
  error: false,
}).on(setDepartureScheduleFiltersStates, (_, newState) => newState);

// REQUESTS
export const fetchDepartureSchedule =
  createEffect<FetchDepartureSchedulePropsT>(({ cb }) => {
    DepartureScheduleService.getAll(undefined, (err, res) => {
      if (err || !res) {
        setDepartureScheduleStates({
          isFetched: false,
          error: true,
          isLoading: false,
        });
        if (cb) {
          cb(err);
        }
        return console.error("При получении графика выездов произошла ошибка");
      }
      setDepartureSchedule(res.data);
      setDepartureScheduleStates({
        isFetched: true,
        error: false,
        isLoading: false,
      });
      if (cb) {
        cb(null, res);
      }
    });
  });

export const fetchDepartureScheduleOne =
  createEffect<FetchDepartureScheduleOnePropsT>(({ id, cb }) => {
    DepartureScheduleService.getOne(id, (err, res) => {
      if (err || !res) {
        setDepartureScheduleOneStates({
          isFetched: false,
          error: true,
          isLoading: false,
        });
        if (cb) {
          cb(err);
        }
        return console.error("При получении графика выездов произошла ошибка");
      }
      setSelectedDepartureSchedule(res.data);
      setDepartureScheduleOneStates({
        isFetched: true,
        error: false,
        isLoading: false,
      });
      if (cb) {
        cb(null, res);
      }
    });
  });

export const fetchDepartureScheduleFilters =
  createEffect<FetchDepartureScheduleFiltersPropsT>(({ cb }) => {
    DepartureScheduleService.getFilters((err, res) => {
      if (err || !res) {
        setDepartureScheduleFiltersStates({
          isFetched: false,
          error: true,
          isLoading: false,
        });
        if (cb) {
          cb(err);
        }
        return console.error("При получении графика выездов произошла ошибка");
      }
      setDepartureScheduleFilters(res.data);
      setDepartureScheduleFiltersStates({
        isFetched: true,
        error: false,
        isLoading: false,
      });
      if (cb) {
        cb(null, res);
      }
    });
  });
